import {
  ControlApiError,
  ControlOriginUnknownError,
} from '@/services/control/control-api-client';

/**
 * Retry predicate shared by every control-api query.
 *
 * A missing origin and any 4xx are settled answers — a 401, a 403 or a 400 for
 * a bad filter will say the same thing next time, and a `503 field mappings not
 * configured` is a deployment fact rather than a blip. Only 5xx beyond that is
 * worth a second look.
 */
export function retryControlApi(failureCount: number, error: Error): boolean {
  if (error instanceof ControlOriginUnknownError) {
    return false;
  }
  if (error instanceof ControlApiError && error.status < 500) {
    return false;
  }
  return failureCount < 2;
}
